import Battery from 'components/batteries/Battery';
import WrapperEmptyState from 'components/layout/WrapperEmptyState';
import PageWrapper from 'components/utils/PageWrapper';
import Batteries from 'pages/Batteries';
import batteryPlaceholder from '../images/battery-unselected.png';

export const batteryRoutes = {
    path: '/batteries',
    element: (
        <PageWrapper titleId="batteries_title">
            <Batteries />
        </PageWrapper>
    ),
    children: [
        {
            index: true,
            element: <WrapperEmptyState imgSrc={batteryPlaceholder} page="Battery" noun="configuration" />,
        },
        {
            path: ':batteryId',
            element: <Battery />,
        },
    ],
};
